<template>
  <div class="fund-position">
    <MoreTitle title="基金持仓" @click="goPage" />
    <RkSwitch v-model="activeTab" :options="options" class="rk-switch--fund" />
    <div class="chart-wrapper">
      <VueEcharts :option="option" class="echarts-container" />
      <div class="echarts-legend">
        <LegendList :data="positionData" :props="{ legendName: 'name', legendColor: 'color' }" />
      </div>
    </div>
    <div class="table-name">
      <span class="main-holding">重仓股票(48.67%)</span>
      <span class="update-time">2020-12-31更新</span>
    </div>
    <RkTable :data="fundPositionData" :show-footer="false">
      <RkTableColumn prop="" label="股票名称" align="left"></RkTableColumn>
      <RkTableColumn prop="" label="持仓数量"></RkTableColumn>
      <RkTableColumn prop="" label="持仓占比"></RkTableColumn>
      <RkTableColumn prop="" label="变动"></RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import RkSwitch from '@/components/common/RkSwitch.vue'
import VueEcharts from '@/components/common/VueEcharts.vue'
import LegendList from '@/components/common/legend/LegendList.vue'
export default {
  components: { RkSwitch, VueEcharts, LegendList },
  inject: ['theme'],
  data() {
    return {
      fundPositionData: [],
      activeTab: '资产',
      options: Object.freeze([
        [
          {
            label: '资产',
            value: '资产'
          },
          {
            label: '行业',
            value: '行业'
          }
        ]
      ]),
      positionData: [
        { value: 1048, name: 'Search Engine', color: '#E54C4B' },
        { value: 735, name: 'Direct', color: '#7DAFF9' },
        { value: 580, name: 'Email', color: '#65B768' },
        { value: 484, name: 'Union Ads', color: '#F4C997' },
        { value: 300, name: 'Video Ads', color: '#E54C4B' },
        { value: 300, name: 'Video Ads', color: '#E54C4B' },
        { value: 300, name: 'Video Ads', color: '#E54C4B' },
        { value: 300, name: 'Video Ads', color: '#E54C4B' },
        { value: 300, name: 'Video Ads', color: '#E54C4B' }
      ]
    }
  },
  computed: {
    option() {
      return {
        dataset: {
          source: this.segmentViews
        },
        series: [
          {
            name: '主营占比',
            type: 'pie',
            radius: ['70%', '100%'],
            encode: {
              name: 'name',
              value: 'incomeRatio'
            },
            label: {
              position: 'center',
              formatter: '{main|1243.61亿元}\n{height|净资产}\n2020-12-31',
              rich: {
                main: {
                  fontSize: 15,
                  fontWeight: 500,
                  color: this.theme['--font-color-1']
                },
                height: {
                  lineHeight: 24
                }
              }
            },
            emphasis: {
              disabled: true
            },
            data: this.positionData
          }
        ]
      }
    }
  },
  methods: {
    goPage() {
      this.$router.push({
        path: '/etf/position',
        query: {
          symbol: this.symbol
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fund-position {
  padding: 0 var(--edge-padding) var(--edge-padding);
  background: var(--bg-color-2);
  .rk-switch--fund {
    margin-bottom: 14px;
  }
  .chart-wrapper {
    display: flex;
    .echarts-container,
    .echarts-legend {
      flex: 1;
      overflow: hidden;
    }
    .echarts-legend {
      display: flex;
      justify-content: center;
    }
  }
  .table-name {
    display: flex;
    justify-content: space-between;
    padding: 15px 0;
  }
  .main-holding {
    font-size: 16px;
    font-weight: 500;
  }
  .update-time {
    font-size: 13px;
    color: var(--font-color-3);
  }
}
</style>
